import React, { SyntheticEvent, useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BusinessDashboard from '~/pages/BusinessTraveller/BusinessDashboard';

import { LE_BUSINESS_TRAVELLER } from '~/consts/businessTraveller';
import { ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER } from '~/consts/roles';

import useCurrentTenant from '~/hooks/useCurrentTenant';
import useCurrentUser from '~/hooks/useCurrentUser';

import BusinessListPanel from '../components/BusinessListPanel';
import DefaultBusinessSettingPanel from '../components/businessSettings/DefaultBusinessSettingPanel';

type BusinessStatus = 'active' | 'deactivated';

// 'active' and 'deactivated' filter the business list by status.
type TabValue = BusinessStatus | 'default' | 'dashboard';

const TAB_VALUES: Array<TabValue> = ['dashboard', 'active', 'deactivated', 'default'];

export default function MainPage() {
  const title = 'Businesses';
  const [activeTab, setActiveTab] = useState<TabValue>('dashboard');
  const { tenant } = useCurrentTenant();
  const { user } = useCurrentUser();
  const canAccessDashboard =
    tenant.brand === LE_BUSINESS_TRAVELLER &&
    [ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER].some((role) => user?.roles?.includes(role));
  const tabs = canAccessDashboard ? TAB_VALUES : TAB_VALUES.filter((tab) => tab !== 'dashboard');
  const visibleTab = activeTab === 'dashboard' && !canAccessDashboard ? 'active' : activeTab;

  function handleTabChange(_event: SyntheticEvent, newValue: number) {
    setActiveTab(tabs[newValue]);
  }

  return (
    <Container>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageHeader title={title} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabs.indexOf(visibleTab)} onChange={handleTabChange}>
          {canAccessDashboard && <Tab label="Dashboard" />}
          <Tab label="Active" />
          <Tab label="Deactivated" />
          <Tab label="Default Business Setting" />
        </Tabs>
      </Box>
      <Box mt={2}>
        {visibleTab === 'dashboard' ? (
          <BusinessDashboard />
        ) : visibleTab === 'default' ? (
          <DefaultBusinessSettingPanel />
        ) : (
          <BusinessListPanel key={visibleTab} status={visibleTab} />
        )}
      </Box>
    </Container>
  );
}
